import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Color Palette */
    --color-primary: #1B263B;          /* Azul oscuro - fondo principal */
    --color-secondary: #24344D;        /* Azul más claro - fondos secundarios */
    --color-tertiary: #2E3A47;         /* Gris muy oscuro - fondos secundarios alternativos */
    
    /* Text Colors */
    --text-primary: #FFFFFF;           /* Blanco puro - texto principal */
    --text-secondary: #E5E5E5;         /* Gris claro - texto secundario */
    --text-disabled: #B0B0B0;          /* Gris medio - texto deshabilitado */
    
    /* Button Colors */
    --btn-primary: #00B4D8;            /* Cian eléctrico - botones primarios */
    --btn-primary-hover: #4DD7EB;      /* Cian más claro - hover botones primarios */
    --btn-primary-active: #0089A6;     /* Cian más oscuro - botones primarios activos */
    
    /* Alert Colors */
    --alert-success: #06D6A0;          /* Verde - alertas de éxito */
    --alert-warning: #FFD166;          /* Amarillo - alertas de advertencia */
    --alert-error: #EF476F;            /* Rojo coral - alertas de error */

    /* Superficies (paneles / tarjetas) — un solo lenguaje reutilizable */
    --surface: rgba(36, 52, 77, 0.72);
    --surface-deep: rgba(11, 19, 32, 0.55);
    --border-soft: rgba(255, 255, 255, 0.06);
    --border-strong: rgba(255, 255, 255, 0.14);

    /* Tipografía */
    --font-sans: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --font-mono: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;

    /* Espaciado (escala 4px) */
    --space-1: 0.25rem;
    --space-2: 0.5rem;
    --space-3: 0.75rem;
    --space-4: 1rem;
    --space-5: 1.5rem;
    --space-6: 2rem;
    --space-8: 3rem;

    /* Radios */
    --radius-sm: 6px;
    --radius: 8px;
    --radius-lg: 12px;
    --radius-pill: 999px;

    /* Sombras */
    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.25);
    --shadow-md: 0 6px 20px rgba(0, 0, 0, 0.28);
    --shadow-lg: 0 16px 48px rgba(0, 0, 0, 0.45);

    /* Capas (z-index) — orden explícito para evitar peleas de stacking */
    --z-sidebar: 900;
    --z-mobilebar: 950;
    --z-toggle: 1000;
    --z-palette: 1200;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: var(--font-sans);
    background-color: var(--color-primary);
    color: var(--text-primary);
    line-height: 1.6;
  }

  /* Foco visible accesible (teclado) — coherente en toda la app */
  :focus-visible {
    outline: 2px solid var(--btn-primary);
    outline-offset: 2px;
    border-radius: 4px;
  }

  a {
    color: var(--btn-primary);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--btn-primary-hover);
    }
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  /* Responsive Typography */
  html {
    font-size: 16px;
    
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--text-primary);
    margin-bottom: 1rem;
    font-weight: 600;
  }

  h1 { font-size: 2.5rem; }
  h2 { font-size: 2rem; }
  h3 { font-size: 1.75rem; }
  h4 { font-size: 1.5rem; }
  h5 { font-size: 1.25rem; }
  h6 { font-size: 1rem; }

  p {
    margin-bottom: 1rem;
    color: var(--text-secondary);
  }
`;

export default GlobalStyles;
